var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3128 0.336708L22.6609 10.6868C23.3852 11.4113 22.8724 12.6499 21.848 12.6499H20.6982V19.55C20.6982 20.465 20.3348 21.3425 19.6879 21.9895C19.041 22.6365 18.1636 23 17.2488 23H16.099V14.9499C16.0991 14.0699 15.7629 13.2232 15.1593 12.5829C14.5557 11.9426 13.7303 11.5573 12.852 11.5056L12.6497 11.4999H10.3501C9.43526 11.4999 8.55791 11.8634 7.91102 12.5104C7.26414 13.1574 6.90073 14.0349 6.90073 14.9499V23H5.75094C4.83612 23 3.95876 22.6365 3.31188 21.9895C2.665 21.3425 2.30158 20.465 2.30158 19.55V12.6499H1.1518C0.128486 12.6499 -0.385469 11.4113 0.338897 10.6868L10.687 0.336708C10.9026 0.121114 11.195 0 11.4999 0C11.8048 0 12.0972 0.121114 12.3128 0.336708ZM12.6497 13.7999C12.9546 13.7999 13.2471 13.9211 13.4627 14.1367C13.6783 14.3524 13.7995 14.6449 13.7995 14.9499V23H9.2003V14.9499C9.20034 14.6682 9.30373 14.3964 9.49087 14.1859C9.67801 13.9754 9.93588 13.8409 10.2156 13.808L10.3501 13.7999H12.6497Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeicon);
export default __webpack_public_path__ + "static/media/homeicon.6012bbe8e6b3769fc6e987d1e87e12d5.svg";
export { ForwardRef as ReactComponent };